import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Géographie",
  icon: "🌍",
  tagline: "Comprenez les dynamiques territoriales, environnementales et urbaines",
  duree: "3 à 5 ans",
  diplome: "Licence",
  mode: "Présentiel",
  nombreDebouches: "8",
  description: "La filière Géographie offre une formation complète sur l'organisation des espaces, les interactions homme-environnement et les enjeux territoriaux. Notre programme combine approches physiques et humaines de la géographie.",
  objectifs: [
    "Maîtriser les fondamentaux de la géographie physique et humaine",
    "Développer des compétences en cartographie et SIG",
    "Comprendre les enjeux environnementaux et territoriaux",
    "Acquérir des compétences en aménagement",
    "Maîtriser les outils de l'analyse spatiale"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Géographie physique", "Géographie humaine", "Cartographie", "Climatologie", "Géomorphologie", "Démographie"] },
    { titre: "Licence 3", matieres: ["Géographie urbaine", "Aménagement du territoire", "Systèmes d'information géographique (SIG)", "Géographie du développement", "Géopolitique", "Écologie et environnement"] }
  ],
  debouches: [
    { titre: "Géographe", description: "Étude et analyse spatiale" },
    { titre: "Urbaniste", description: "Planification urbaine" },
    { titre: "Cartographe", description: "Production de cartes" },
    { titre: "Consultant en environnement", description: "Conseil environnemental" },
    { titre: "Chargé d'aménagement", description: "Aménagement territorial" },
    { titre: "Enseignant", description: "Enseignement de la géographie" }
  ],
  competences: ["Maîtrise de la cartographie et des SIG", "Compétences en analyse spatiale", "Compréhension des enjeux environnementaux", "Capacité d'analyse territoriale", "Compétences en aménagement"]
};

export default function Geographie() {
  return <FiliereTemplate filiere={filiereData} />;
}